import { logger } from '#utils/logging/logger';

import type { TrackingData } from '../types';

export function defaultDispatcher(trackingData: TrackingData) {
	if (process.env.NODE_ENV !== 'production') {
		logger.info(trackingData);
	}

	logger.warn('No <TracktorProvider /> setup.');
}

// We'll mark this as the default dispatcher,
// this is used to determine whether the consumer tries to implement multiple `<Provider/>`'s.
defaultDispatcher.isDefault = true;
